import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const UploadIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="uploadIcon"
  >
    <title id="uploadIcon">Upload icon</title>
    <path
      d="M8 2.48306V10.9091C8 11.3108 7.67439 11.6364 7.27273 11.6364C6.87106 11.6364 6.54545 11.3108 6.54545 10.9091V2.48306L4.87789 4.15062C4.59388 4.43464 4.13339 4.43464 3.84938 4.15062C3.56536 3.86661 3.56536 3.40612 3.84938 3.1221L6.75847 0.213013C7.04248 -0.0710044 7.50297 -0.0710044 7.78699 0.213013L10.6961 3.1221C10.9801 3.40612 10.9801 3.86661 10.6961 4.15062C10.4121 4.43464 9.95158 4.43464 9.66756 4.15062L8 2.48306ZM0 9.45455C0 9.05288 0.325611 8.72727 0.727273 8.72727C1.12893 8.72727 1.45455 9.05288 1.45455 9.45455V13.8182C1.45455 14.2198 1.78016 14.5455 2.18182 14.5455H12.3636C12.7653 14.5455 13.0909 14.2198 13.0909 13.8182V9.45455C13.0909 9.05288 13.4165 8.72727 13.8182 8.72727C14.2198 8.72727 14.5455 9.05288 14.5455 9.45455V13.8182C14.5455 15.0232 13.5686 16 12.3636 16H2.18182C0.976833 16 0 15.0232 0 13.8182V9.45455Z"
      fill="#24203F"
    />
  </svg>
);

export { UploadIcon };
